module.exports = __webpack_public_path__ + "img/agents (копия).62cf5541.svg";